/**
 * @file spy 监控打点
 * @author yijunjie
 * @document http://wiki.baidu.com/display/SPY/spy-client+SDK
 * @platform http://spy.baidu.com/#/autoreport/setting/13/98
 * @time 2021.4.1
 */

import SpyClient from 'spy-client';
import _ from 'lodash';
import request from '../../../utils/request';
import {captureAPIException} from '../utils/weirwood';

const group = 'ai_anchor_interface';

/**
 * Spy 类
 */
class Spy {
    constructor(options = {}) {
        this.defaultOptions = {
            pid: '13_98', // 申请的电商带货的pid
            lid: '', // 暂时没用上
            sample: 1
        };
        this.init(options);
    }

    init(options) {
        const mergeOptions = Object.assign(this.defaultOptions, options);
        this.spy = new SpyClient(mergeOptions);
    }

    sendPerf({params}) {
        this.spy.sendPerf({
            group,
            info: {
                ...params
            }
        });
    }

    sendExcept({params = {}}) {
        this.spy.sendExcept({
            group: params.group || group,
            info: {
                msg: 'code error',
                ...params
            }
        });
    }
}

const spy = new Spy();

export default spy;


export const spyRequest = async (url, options) => {
    const startTime = new Date().getTime();
    const res = await request(url, options);
    // 接口耗时打点
    const endTime = new Date().getTime();
    const regArr = url.match(/.*\/([a-zA-Z0-9_]+)(\?|\B)/);
    const logUrl = _.get(regArr, '[1]', '');
    // spy.sendPerf({
    //     params: {
    //         [logUrl]: endTime - startTime
    //     }
    // });
    // addUserTiming({
    //     [`x_huibo_url_fp_${logUrl}`]: endTime - startTime
    // });
    // 请求失败打点

    if (res && res.errno !== 0 && +res.code !== 0) { // code为曦灵插件返回码字段
        if (process.env.NODE_ENV === 'development' || location.hostname !== 'huibo.baidu.com') {
            return res;
        }

        switch (res.errno) {
            case 12:
                spy.sendExcept({
                    params: {
                        msg: JSON.stringify({
                            hostname: location.hostname,
                            errno: res.errno || res.status,
                            url,
                            errmsg: res.errmsg
                        })
                    }
                });
                break;
            default:
                spy.sendExcept({
                    params: {
                        msg: JSON.stringify({
                            hostname: location.hostname,
                            errno: res.errno || res.status,
                            url,
                            errmsg: res.errmsg,
                            logid: res.logid
                        })
                    }
                });
                // weiwood上报
                captureAPIException({
                    url,
                    method: options.method || 'GET',
                    status: res.errno || res.status,
                    response: res,
                    params: options
                });
        }
    }
    return res;
};
